
import {
  LOADERDOTS_VARIANT_DEFAULT,
  LOADERDOTS_VARIANT_WHITE,
} from '../../utils/constants'
export default {
  props: {
    variant: {
      type: String,
      default: LOADERDOTS_VARIANT_DEFAULT,
      validator(val) {
        return [LOADERDOTS_VARIANT_DEFAULT, LOADERDOTS_VARIANT_WHITE].includes(
          val,
        )
      },
    },
  },
  computed: {
    dotClass() {
      return [
        this.variant === LOADERDOTS_VARIANT_WHITE
          ? 'tw-bg-white tw-animate-pulsing-white'
          : 'tw-bg-gray-400 tw-animate-pulsing-gray',
      ]
    },
  },
}
